<p-dialog
    [(visible)]="visible"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [closeOnEscape]="true"
    [dismissableMask]="true"
    [style]="{width: '840px'}"
    styleClass="p-fluid comunica-contributo-dialog"
    [showHeader]="false"
    (onHide)="hide()">

    <div class="dialog-container">
        <div class="dialog-header">
            <div class="header-content">
                <i class="pi pi-book header-icon"></i>
                <h2>Comunica determina</h2>
            </div>
            <button
                pButton
                pRipple
                icon="pi pi-times"
                class="p-button-rounded p-button-text close-btn"
                (click)="hide()">
            </button>
        </div>

        <div class="dialog-content">
            <div class="form-container">
                <div class="form-row">
                    <div class="field">
                        <label for="numeroDetermina">Numero determina <span class="required">*</span></label>
                        <input
                            id="numeroDetermina"
                            type="text"
                            pInputText
                            [(ngModel)]="numeroDetermina"
                            placeholder="Inserisci il numero della determina"
                            class="w-full"
                            required>
                    </div>

                    <div class="field">
                        <label for="dataDetermina">Data determina</label>
                        <p-calendar
                            id="dataDetermina"
                            [(ngModel)]="dataDetermina"
                            dateFormat="dd/mm/yy"
                            [showIcon]="true"
                            [showButtonBar]="true"
                            [maxDate]="today"
                            placeholder="Seleziona data"
                            appendTo="body"
                            styleClass="w-full">
                        </p-calendar>
                    </div>

                    <div class="field">
                        <label for="importoLiquidato">Importo liquidato (€) <span class="required">*</span></label>
                        <p-inputNumber
                            id="importoLiquidato"
                            [(ngModel)]="importoLiquidato"
                            [min]="0"
                            mode="decimal"
                            [useGrouping]="true"
                            locale="it-IT"
                            [minFractionDigits]="2"
                            [maxFractionDigits]="2"
                            placeholder="Importo liquidato"
                            styleClass="w-full importo-liquidato-input"
                            required>
                        </p-inputNumber>
                        <!-- <small class="text-muted">Precompilato con l'importo della rendicontazione, modificabile.</small> -->
                    </div>
                </div>

                <div class="field">
                    <label for="noteDetermina">Note</label>
                    <textarea
                        id="noteDetermina"
                        pInputTextarea
                        [(ngModel)]="note"
                        [rows]="3"
                        placeholder="Inserisci eventuali note"
                        class="w-full"
                        style="resize: vertical">
                    </textarea>
                </div>

                <div class="field">
                    <label for="fileDetermina">File determina <span class="required">*</span></label>

                    <p-fileUpload *ngIf="!file"
                      #fileUpload
                      mode="basic"
                      chooseLabel="Seleziona P7M"
                      accept="application/p7m"
                      [maxFileSize]="10000000"
                      [auto]="true"
                      [style]="{'width':'100%'}"
                      styleClass="p-button-outlined p-button-primary upload-button"
                      (onSelect)="onFileSelect($event)"
                      (onClear)="onFileClear()"
                      [disabled]="loading"
                        styleClass="w-full"
                        required>
                    </p-fileUpload>
                </div>
                  <div *ngIf="file" class="file-info mt-3">
                    <i class="pi pi-file-pdf" style="font-size: 1.5rem; color: #5351b9;"></i>
                    <div class="file-details">
                      <span class="file-name">{{ file.name }}</span>
                      <span class="file-size">{{ (file.size / 1024 / 1024).toFixed(2) }} MB</span>
                    </div>

                    <button
                      pButton
                      type="button"
                      icon="pi pi-times"
                      class="p-button-rounded p-button-text p-button-danger ml-auto"
                      pTooltip="Rimuovi file"
                      [disabled]="loading"
                      (click)="onFileClear()">
                    </button>
                  </div>
            </div>
        </div>

        <div class="dialog-footer">
            <button
                pButton
                pRipple
                label="Annulla"
                icon="pi pi-times"
                class="p-button-text"
                [disabled]="loading"
                (click)="hide()">
            </button>
            <button
                pButton
                pRipple
                label="Salva"
                icon="pi pi-check"
                class="p-button-success"
                (click)="salva()"
                [disabled]="!numeroDetermina || !file || importoLiquidato === null || importoLiquidato < 0 || loading">
                <i *ngIf="loading" class="pi pi-spin pi-spinner" style="margin-right: 0.5rem"></i>
            </button>
        </div>
    </div>
</p-dialog>

<p-toast position="top-right"></p-toast>
